export const EBuyTicketSessionKeys = {
  TICKETS_FORM_DATA: "ticketsFormData",
  EVENTS_TICKETS: "eventsTickets",
  GROUP_TICKETS_INFO_STATE: "groupTicketsInfoState",
  SELECTED_DONATE_AMOUNT: "selectedDonateAmount",
}
